import { render, staticRenderFns } from "./wosByPub.vue?vue&type=template&id=7bdad816"
import script from "./wosByPub.vue?vue&type=script&lang=js"
export * from "./wosByPub.vue?vue&type=script&lang=js"
import style0 from "./wosByPub.vue?vue&type=style&index=0&id=7bdad816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports